import React from 'react';
import { Link, useParams } from 'react-router-dom';

import 'react-image-gallery/styles/css/image-gallery.css';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";
import { GET_CAR_AGENTS_DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};
export default function CarAgentsDetails() {
  const [image, setImage] = useState([]);

  var home = useSelector((state) => state.home);
  const carAgentDetailList = home?.getCarAgentDetailList?.data?.[0];
  const dispatch = useDispatch();

  const { agentDetailId } = useParams();

  useEffect(() => {
    try {
      // console.log('fetch data part', data);
      axios

        .get(
          `https://api.carsavenue.com/api/carAgent/listing?carAgentId=` +
            agentDetailId,

          config
        )

        .then((res) => {
          console.log('heeee<<<<', res);
          dispatch({
            type: GET_CAR_AGENTS_DETAIL_LIST,
            payload: res.data.response,
          });

          // setgarageDataDetail(res);

          console.log('heeee<<<<', res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      // Swal.fire('Incorrect Credentials', '', 'error');
    }
  }, []);

  useEffect(() => {
    const value = [];
    carAgentDetailList?.businessMedia?.forEach((elem) => {
      const dt = {
        original: elem?.media?.path,
      };
      value.push(dt);
    });
    setImage(value);
  }, [carAgentDetailList]);

  console.log('carAgentList', carAgentDetailList);
  return (
    <div>
      <div class="user-banner">
        <CommonBanner bannerImages={image} />

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-4 col-md-3">
                      <img
                        style={{
                          width: '6rem',
                          height: '6rem',
                          borderRadius: '50%',
                          objectFit: 'contain',
                          backgroundColor: '#fff',
                        }}
                        src={
                          carAgentDetailList?.businessMedia?.[0]?.media?.path
                        }
                        alt=""
                        class="img-fluid user-garage-logo"
                      />
                    </div>
                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">{carAgentDetailList?.carAgentName}</h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <Link
                            to="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </Link>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <Link to="https://wa.me/12345678">
                            <i class="fab fa-whatsapp"></i>
                          </Link>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <Link to="tel:12345678">
                            <i class="fas fa-phone"></i>
                          </Link>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#map-modal"
                          >
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  <p class="mb-3">
                    <span class="open-time">Open now</span> |{' '}
                    <span class="close-time">Close 10:00 PM</span>
                  </p>
                  <ul class="list-inline mb-0">
                    {carAgentDetailList?.website && (
                      <li class="list-inline-item">
                        <a
                          href={externalUrl(carAgentDetailList?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            class="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/facebook.png"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/instagram.png"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/twitter.png"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/youtube.png"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/linkedin.png"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/snapchat.png"
                          alt=""
                        />
                      </Link>
                    </li>
                    <li class="list-inline-item">
                      <Link to="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/googleplus.png"
                          alt=""
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content-area">
        <div class="container">
          <h3>About Us</h3>
          <p>{carAgentDetailList?.about}</p>

          <h4>Our Vehicles</h4>

          <div class="row">
            {carAgentDetailList?.car.map((car, indx) => (
              <div key={indx} class="col-6 col-sm-6 col-md-4 col-lg-3 mb-5">
                <div class="user-cars-agents-wrap">
                  <Link to="/user-car-agent-listings">
                    <div class="line-a">
                      <img
                        style={{ width: '10rem', height: '10rem' }}
                        src={
                          car?.carMedia?.[0] !== undefined
                            ? car?.carMedia?.[0]?.meida?.path
                            : `assets/images/user/cars-agents/a.jpg`
                        }
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                    <div class="line-b">
                      {car?.brand?.name} {car?.carName}
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <h4>Service</h4>

          <div class="row mb-4">
            {carAgentDetailList?.services.map((service, indx) => (
              <div
                key={indx}
                class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 col-md-0"
              >
                <Link
                  to="#storeModel"
                  data-fancybox
                  class="user-si-row"
                  style={{ textTransform: 'capitalize' }}
                >
                  {service?.serviceType}
                </Link>
              </div>
            ))}
          </div>
          {/* [CF-5] Website moved to an icon beside the social icons. */}
        </div>
      </div>
    </div>
  );
}
